interface BrandLoginPortalInputs {
   selectedPortal?: string | null;
   lastPortal?: string | null;
   portalBrand?: string | null;
}

/**
 * Resolves which portal's login page a not-yet-authenticated user on an /lms
 * route should be redirected to.
 *
 * Regression guard: on a hard reload the Auth0 SDK starts cold, so the user
 * briefly appears unauthenticated and lands in the brand-login redirect before
 * silent auth completes. If we redirect to the configured `portalBrand`
 * (e.g. the umbrella default 'ipapolo'), the /login/[portal] page's brandLogin()
 * overwrites localStorage['selectedPortal'] — reverting the user's brand.
 *
 * The user's explicit selection must win, then their last-known portal, then the
 * build's configured brand, then a hardcoded fallback.
 */
export function resolveBrandLoginPortal({
   selectedPortal,
   lastPortal,
   portalBrand,
}: BrandLoginPortalInputs): string {
   return selectedPortal || lastPortal || portalBrand || 'ipapolo';
}
